import { post } from './index';
import { ApiResponse, LoginResponseType } from '../types';

export async function login(email: string, password: string) {
  const response = await post<ApiResponse<LoginResponseType>>('/admin/auth/login', { email, password });
  return response.data;
}
